// Import and configure all plugins
import './axios'
import './fontawesome'

// Echo/Pusher configuration (optional)
// import './echo'

console.log('✅ Plugins loaded') 